import { render, staticRenderFns } from "./questionView.vue?vue&type=template&id=5b7ed5aa"
import script from "./questionView.vue?vue&type=script&lang=js"
export * from "./questionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports